import styled from "styled-components";

export const NoResultViewStyled = styled.div``;

export const NoSearchResultsWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
`;
